// extracted by mini-css-extract-plugin
module.exports = {"defaulIcon":"infoitem_defaulIcon__1u_BJ","valueCol":"infoitem_valueCol__wF45n"};